import React, { useState } from "react";

/**
 * SimpleButton — one small, self-contained button for calendar event actions
 * (delete/update/accept/decline/...). Replaces the old per-button
 * styles.actionButton(variant, size) + manual onMouseEnter/onMouseLeave pair
 * repeated at every call site with a single component that owns its own
 * hover state.
 */
const VARIANTS = {
  default: { bg: "#64748b", bgHover: "#475569" },
  primary: { bg: "#2563eb", bgHover: "#1d4ed8" },
  danger: { bg: "#dc2626", bgHover: "#b91c1c" },
  success: { bg: "#16a34a", bgHover: "#15803d" },
  warning: { bg: "#d97706", bgHover: "#b45309" },
};

const SimpleButton = ({
  icon: Icon,
  children,
  onClick,
  variant = "default",
  type = "button",
  disabled = false,
}) => {
  const [hover, setHover] = useState(false);
  const c = VARIANTS[variant] || VARIANTS.default;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "10px 16px",
        borderRadius: "8px",
        border: "none",
        fontSize: "14px",
        fontWeight: 600,
        color: "#fff",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        background: hover && !disabled ? c.bgHover : c.bg,
        transition: "background 0.15s ease",
      }}
    >
      {Icon && <Icon size={16} />}
      {children}
    </button>
  );
};

export default SimpleButton;
